// Royal Mail only accepts these three formats. Anything else is grouped as
// "NoFormat" at dispatch and never gets a label, so they must not be offered.
export const PRODUCT_FORMATS = ['Letter', 'Large letter', 'Parcel'];
